import React, { useEffect, useRef } from "react";
import { View } from "react-native";
import { Icon } from "react-native-elements";
import { useState } from "react";
import SearchBar from "react-native-elements/dist/searchbar/SearchBar-ios";
import { THEME_COLORS } from "../../themes";
import TooltipV3 from "../TooltipV3";

function ListSearchInput({
  onSearch,
  placeholder,
  searchProp = "",
  debouncedSearchEnable = false,
}: {
  onSearch: any;
  placeholder?: string;
  searchProp?: string;
  debouncedSearchEnable?: boolean;
}) {
  const [search, setSearch] = useState("");
  const textRef = useRef("");

  useEffect(() => {
    setSearch(searchProp);
    textRef.current = searchProp;
  }, [searchProp]);

  const searchPress = (val?: any) => {
    onSearch(val ?? search);
    textRef.current = val ?? search;
  };

  return (
    <View style={{ flexDirection: "row", alignItems: "center" }}>
      <TooltipV3 open={search != textRef.current} title="Press enter to search">
        <SearchBar
          placeholder={placeholder ?? "Search lead ID, cars, CGT...."}
          onChangeText={(text: string) => {
            if(debouncedSearchEnable){
              searchPress(text);
              setSearch(text);
            }else{
              setSearch(text);
            }
          }}
          onKeyPress={(val: any) => {
            if (val.key === "Enter") {
              searchPress();
            }
          }}
          value={search}
          searchIcon={null}
          inputContainerStyle={{
            backgroundColor: THEME_COLORS.grey2,
            width: "30vw",
          }}
          containerStyle={{ paddingBottom: 0, paddingTop: 0 }}
          inputStyle={{ outline: "none", fontSize: 15, paddingLeft: 8 }}
          cancelButtonTitle=""
          cancelButtonProps={{ buttonStyle: { width: 8 } }}
          onClear={() => {
            setSearch("");
            searchPress("");
          }}
        />
      </TooltipV3>
      <Icon
        disabled={search == textRef.current}
        name="search"
        size={30}
        color={search == textRef.current ? THEME_COLORS.grey1 : THEME_COLORS.purple}
        disabledStyle={{ backgroundColor: "#00000000" }}
        onPress={() => searchPress()}
      />
    </View>
  );
}

export default ListSearchInput;
